// import CognitoIdentityServiceProvider from 'aws-sdk/clients/cognitoidentityserviceprovider';
// import CognitoIdentityCredentials  from 'aws-sdk/clients/cognitoidentity';

// // import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
// // import { userPool } from "../aws";

// const { VITE_APP_AWS_REGION, VITE_APP_USER_POOL_ID, VITE_APP_IDENTITY_POOL_ID } = import.meta.env;

// const signInAws = (email, password, callback=()=>{}) => {
//     // var authenticationData = {
//     //   Username: email,
//     //   Password: password,
//     // };
    
//     // var authenticationDetails = new AuthenticationDetails(authenticationData);

//     // var userData = {
//     //   Username: email,
//     //   Pool: userPool,
//     // };
//     // var cognitoUser = new CognitoUser(userData);

//     // cognitoUser.authenticateUser(authenticationDetails, {
//     //   onSuccess: function(result) {
//     //     let accessToken = result.getAccessToken().getJwtToken();
//     //     localStorage.setItem("accessToken", accessToken);
        
//     //     // Set AWS region
//     //     CognitoIdentityServiceProvider.config.update({ region: VITE_APP_AWS_REGION });
        
//     //     // Set AWS credentials
//     //     CognitoIdentityServiceProvider.config.credentials = new CognitoIdentityCredentials({
//     //       IdentityPoolId: VITE_APP_IDENTITY_POOL_ID,
//     //       Logins: {
//     //         [`cognito-idp.${VITE_APP_AWS_REGION}.amazonaws.com/${VITE_APP_USER_POOL_ID}`]: result.getIdToken().getJwtToken(),
//     //       },
//     //     });

//     //     // Refresh credentials
//     //     CognitoIdentityServiceProvider.config.credentials.refresh(error => {
//     //       if (error) {
//     //         console.error(error);
//     //       } else {
//     //         cognitoUser.getSession(function(err, session) {
//     //           if (err) {
//     //             console.error(err);
//     //           } else if (session.isValid()) {
//     //             cognitoUser.getUserAttributes(function(err, attributes) {
//     //               if (err) {
//     //                 callback(err, null);
//     //               } else {
//     //                 let userAttributes = {};
//     //                 for (let i = 0; i < attributes.length; i++) {
//     //                   const attribute = attributes[i];
//     //                   userAttributes[attribute.Name] = attribute.Value;
//     //                 }
//     //                 callback(null, userAttributes);
//     //               }
//     //             });
//     //           }
//     //         });
//     //         console.log('Successfully logged!');
//     //       }
//     //     });
//     //   },

//     //   onFailure: function(err) {
//     //     console.log(err.message, "onFailure");
//     //     callback(err.message, null);
//     //   },
//     // });
// }

// export default signInAws;




// import AWS from 'aws-sdk/global';
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import { userPool } from "../aws";


const { VITE_APP_AWS_REGION, VITE_APP_USER_POOL_ID, VITE_APP_IDENTITY_POOL_ID } = import.meta.env;

const signInAws = (email, password, callback=()=>{}) => {

    var authenticationData = {
      Username: email,
      Password: password,
    };
    
    var authenticationDetails = new AuthenticationDetails(authenticationData);

    var userData = {
      Username: email,
      Pool: userPool,
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function(result) {
        console.log(result, "onSuccess:res");
        // let username = cognitoUser.getUsername();
        // let accessToken = result.getAccessToken().getJwtToken();
        let accessToken = result.getIdToken().getJwtToken();
        localStorage.setItem("accessToken", `Bearer ${accessToken}`);
        // localStorage.setItem("username", username);

        // console.log(result.accessToken.payload.username, "=result.accessToken.payload.username");
      
        const sub = result.accessToken.payload.username
        // localStorage.setItem("user-sub", sub);
        callback(null, { name: "Faisal Ali", sub });
        
        // //POTENTIAL: Region needs to be set if not already set previously elsewhere.
        // AWS.config.region = VITE_APP_AWS_REGION;
    
        // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        //   IdentityPoolId: VITE_APP_IDENTITY_POOL_ID, // your identity pool id here
        //   Logins: {
        //     // Change the key below according to the specific region your user pool is in.
        //     [`cognito-idp.${VITE_APP_AWS_REGION}.amazonaws.com/${VITE_APP_USER_POOL_ID}`]: result.getIdToken().getJwtToken(),
        //   },
        // });
    
        // // //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
        // AWS.config.credentials.refresh(error => {
        //   if (error) {
        //     console.error(error);
        //   } else {
        //     // Instantiate aws sdk service objects now that the credentials have been updated.
        //     // example: var s3 = new AWS.S3();

        //     cognitoUser.getSession(function(err, session) {
        //       if (err) {
        //         console.error(err);
        //       } else if (session.isValid()) {
        //         cognitoUser.getUserAttributes(function(err, attributes) {
        //           if (err) {
        //             // handle error
        //           } else {
        //             let userAttributes = {};
        //             for (let i = 0; i < attributes.length; i++) {
        //               const attribute = attributes[i];
        //               userAttributes[attribute.Name] = attribute.Value;
        //             }
        //             // console.log(userAttributes, " = cognitoUser.getUserAttributes");
        //             callback(null, userAttributes);    // on this
        //           }
        //         });
        //       }
        //     });

        //     console.log('Successfully logged!');
        //   }
        // });
      },
    
      // mfaRequired: function(codeDeliveryDetails) {
      //   // MFA is required to complete user authentication.
      //   // Get the code from user and call
      //   // cognitoUser.sendMFACode(mfaCode, this)
      //   callback(null, "success");
      // },

      // mfaSetup: function(challengeName, challengeParameters) {
      //   // cognitoUser.associateSoftwareToken(this);
      //   console.log(challengeName, challengeParameters);
      // },

      onFailure: function(err) {
        // alert(err.message || JSON.stringify(err));
        console.log(err.message, "onFailure");
        callback(err.message, null);
      },
    });
}

export default signInAws;